export class FreightForwarder {
  id: number | null = null;
  name: string | null = null;
  address: string | null = null;
  countryId: number | null = null;
  poBox: number | null = null;
  phoneNumber: string | null = null;
  emailAddress: string | null = null;
  webSiteUrl: string | null = null;
  crNumber: number | null = null;
  latitude: number | null = null;
  longitude: number | null = null;
  logo: string | null = null;
  placeId: string | null = null;
  odooId: number | null = null;
  defaultContactId: number | null = null;
  companyId: number | null = null;
}
